<script setup>
/**
 * FormControlModulestructureEndYear
 * Composition-based wrapper around the standard text form control.
 * Evaluates field type configurations on mount, dropping visibility from the
 * orchestrator layout if the target component attribute is not explicitly a 'date'.
 */
import { onMounted } from 'vue';
import FormControlTypeText from '@/common/form-control-type/FormControlTypeText.vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Contextual visibility guard: If this structure element's type
     * is not 'date', drop visibility from the orchestration form layer.
     */
    if (props.currentData?.type !== 'date' && props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>
    <FormControlTypeText v-bind="$props" v-if="!field.hidden"/>
</template>

<style scoped>
/* Presentation and sizing properties are inherited directly from FormControlTypeText */
</style>